import { Injectable, inject } from '@angular/core';

import { HttpService } from '@bbraun/helpex/src/lib/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { UiConfig } from '../../definitions/interfaces/layout/configs/ui-config';
import { User, UserSearchResult } from '../../definitions/interfaces/user/user';
import { UserRelation } from '../../definitions/interfaces/user/user-relation';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private httpService = inject(HttpService);

  public getUser(): Observable<User> {
    return this.httpService.request('v2/user')
      .get(environment.backendUrls.CUSTOMER);
  }

  public searchUsers(searchString: string): Observable<Array<UserSearchResult>> {
    return this.httpService.request('v1/users')
      .param('searchString', searchString)
      .get(environment.backendUrls.CUSTOMER);
  }

  public getUiConfigs(userId: string, configurationKey?: string): Observable<{ payload: Array<UiConfig> }> {
    let request = this.httpService.request(`v1/user/${userId}/configurations`);
    if (configurationKey) {
      request = request.param('configurationKey', configurationKey);
    }

    return request.get(environment.backendUrls.CUSTOMER);
  }

  public updateUiConfig(userId: string, uiConfig: UiConfig): Observable<void> {
    return this.httpService.request(`v1/user/${userId}/configurations`)
      .param('configurationKey', uiConfig.configurationKey)
      .body(uiConfig.configuration)
      .put(environment.backendUrls.CUSTOMER);
  }

  public addUserRelation(userId: string, relation: UserRelation): Observable<UserSearchResult> {
    return this.httpService.request(`v1/users/${userId}/relations`)
      .body(relation)
      .post(environment.backendUrls.CUSTOMER);
  }

  public removeUserRelation(userId: string, relation: UserRelation): Observable<UserSearchResult> {
    return this.httpService.request(`v1/users/${userId}/relations`)
      .param('relationType', relation.relationType)
      .param('objectId', relation.objectId)
      .delete(environment.backendUrls.CUSTOMER);
  }
}
